<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Cd Usuro</label>

        <b-form-group :invalid-feedback="violations['cdUsuro']" :state="!violations['']">

          <b-form-input v-model="ssv2307UsuroCadtrCrtor.cdUsuro" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Tp Perfl Usuro</label>

        <b-form-group :invalid-feedback="violations['tpPerflUsuro']" :state="!violations['']">

          <select class="custom-select" v-model="ssv2307UsuroCadtrCrtor.tpPerflUsuro" placeholder="Perfil do usuário" :required="true" :readonly="false">
            <option></option>

            <option value="U">Padrão</option>

            <option value="G">Gerente</option>

          </select>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2307UsuroCadtrCrtor', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>